

import {defineComponent, PropType} from "vue";

export const ButtonTypeKeys = ["Hero", "Primary", "Secondary", "Tertiary", "Text"] as const;
export type ButtonType = typeof ButtonTypeKeys[number];

export default defineComponent({
  name: "Button",
  props: {
    type: {
      type: String as PropType<ButtonType>,
      default: "Primary"
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isIconOnly: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  setup(props, context) {
    return () => <button class={[
      'button',
      `button--${props.type}`,
      props.isActive ? 'button--active' : '',
      props.isDisabled ? 'button--disabled' : '',
      props.isIconOnly ? 'button--icon' : ''
    ]}>
      {context.slots.default?.()}
    </button>
  }
})
